import api from './api';

// Couleurs par défaut (fallback)
const defaultTheme = {
  'color-primary': '#FACC15',
  'color-secondary': '#1E2530',
  'color-background': '#0F1419',
  'color-surface': '#23262F',
  'color-text': '#F3F4F6',
  'color-text-secondary': '#9CA3AF'
};

// Appliquer les variables CSS au document
export const applyThemeToDocument = (settings) => {
  const root = document.documentElement;
  
  // Mapper les clés de la BDD (color_primary) vers les variables CSS (--color-primary)
  Object.entries(settings).forEach(([key, value]) => {
    if (key.startsWith('color_')) {
      const cssVar = `--${key.replace(/_/g, '-')}`;
      root.style.setProperty(cssVar, value);
      console.log(`🎨 Thème appliqué: ${cssVar} = ${value}`);
    }
  });
};

// Appliquer le thème par défaut
export const applyDefaultTheme = () => {
  const root = document.documentElement;
  Object.entries(defaultTheme).forEach(([key, value]) => {
    root.style.setProperty(`--${key}`, value);
  });
  console.log('🎨 Thème par défaut appliqué');
};

// Charger et appliquer le thème depuis l'API
export const loadAndApplyTheme = async () => {
  try {
    const response = await api.get('/settings');
    if (response.data.success && response.data.settings) {
      applyThemeToDocument(response.data.settings);
      return response.data.settings;
    } else {
      applyDefaultTheme();
      return defaultTheme;
    }
  } catch (error) {
    console.error('Erreur chargement thème:', error);
    applyDefaultTheme();
    return defaultTheme;
  }
};

// Initialiser le thème (à appeler au démarrage de l'app)
export const initTheme = () => {
  // Appliquer immédiatement le thème par défaut pour éviter le flash
  applyDefaultTheme();
  
  // Puis charger le thème personnalisé depuis l'API
  loadAndApplyTheme();
};
